<div class="p-6 h-dvh grid grid-cols-1 lg:grid-cols-[1fr_1fr] text-center relative">
  <main id="main-content" tabindex="-1" class="contents focus:outline-none">
    <router-outlet class="hidden"></router-outlet>
  </main>
  <img
    src="../../../../assets/images/frame-17@3x.png"
    class="hidden lg:block w-full h-full lg:max-h-[calc(100dvh_-_48px)] object-cover rounded-3xl"
    alt="Far East Consortium building"
  />
</div>
